import React from 'react';
import './Clients.css';

// Client data
const clients = [
  {
    id: 1,
    name: 'Bank of Tanzania',
    shortName: 'BOT',
    industry: 'Banking'
  },
  {
    id: 2,
    name: 'PwC Tanzania',
    shortName: 'PwC',
    industry: 'Consulting'
  },
  {
    id: 3,
    name: 'Forest Hill Hotel',
    shortName: 'FH',
    industry: 'Hospitality'
  },
  {
    id: 4,
    name: 'Holtan East Africa',
    shortName: 'HEA',
    industry: 'Construction'
  },
  {
    id: 5,
    name: 'CRDB Bank',
    shortName: 'CRDB',
    industry: 'Banking'
  },
  {
    id: 6,
    name: 'Sanefam Construction',
    shortName: 'SC',
    industry: 'Construction'
  },
  {
    id: 7,
    name: 'PAPU Towers',
    shortName: 'PAPU',
    industry: 'Real Estate'
  }
];

const Clients = () => {
  // Double the clients array for seamless infinite scroll
  const doubledClients = [...clients, ...clients];

  return (
    <section className="clients" id="clients">
      <div className="clients__container">
        {/* Header */}
        <div className="clients__header">
          <span className="section-label">Our Partners</span>
          <h2 className="section-title">
            Trusted by <span className="text-accent">Industry Leaders</span>
          </h2>
          <p className="clients__subtitle">
            We're proud to have served some of Tanzania's most prestigious organizations, 
            delivering excellence in every project.
          </p>
        </div>

        {/* Marquee Container */}
        <div className="clients__marquee-wrapper">
          {/* First Row - Moving Left */}
          <div className="clients__marquee clients__marquee--left">
            <div className="clients__track">
              {doubledClients.map((client, index) => (
                <div className="client-card" key={`left-${client.id}-${index}`}>
                  <div className="client-card__badge">
                    <span>{client.shortName}</span>
                  </div>
                  <div className="client-card__info">
                    <span className="client-card__name">{client.name}</span>
                    <span className="client-card__industry">{client.industry}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Gradient Overlays */}
          <div className="clients__gradient clients__gradient--left"></div>
          <div className="clients__gradient clients__gradient--right"></div>
        </div>

        {/* Stats Row */}
        <div className="clients__stats">
          <div className="clients__stat">
            <span className="clients__stat-number">7+</span>
            <span className="clients__stat-label">Major Clients</span>
          </div>
          <div className="clients__stat-divider"></div>
          <div className="clients__stat">
            <span className="clients__stat-number">50+</span>
            <span className="clients__stat-label">Projects Delivered</span>
          </div>
          <div className="clients__stat-divider"></div>
          <div className="clients__stat">
            <span className="clients__stat-number">100%</span>
            <span className="clients__stat-label">Client Satisfaction</span>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="clients__bg-pattern"></div>
    </section>
  );
};

export default Clients;
